import { css } from 'react-emotion';
import { animationTransition } from '../../variables';

const TOGGLE_WIDTH = 52;
const THUMB_WIDTH = 28;

export namespace styles {
  export const toggleWrapper = css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  });

  export const toggle = (checked?: boolean, disabled?: boolean) =>
    css({
      marginRight: 8,
      cursor: disabled ? 'not-allowed' : 'pointer',
      position: 'relative',
      height: 20,
      width: TOGGLE_WIDTH,
      borderRadius: 48,
      border: '1px solid #fff',
      backgroundColor: checked ? '#5ba4e5' : '#e8e8e8',
      transition: animationTransition('background-color'),
      appearance: 'none',
      outline: 'none',
      '::after': {
        borderRadius: '50%',
        content: '" "',
        position: 'absolute',
        display: 'block',
        width: THUMB_WIDTH,
        height: THUMB_WIDTH,
        top: -4,
        left: -4,
        backgroundColor: '#ffffff',
        boxShadow: '1px 2px 6px 0 rgba(0, 0, 0, 0.25)',
        transition: animationTransition('transform'),
        transform: checked ? `translate3d(${TOGGLE_WIDTH - THUMB_WIDTH + 8}px, 0, .001px)` : 'translate3d(0, 0, .001px)'
      }
    });
}
